module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "edit-container"
  }, [_vm._c('div', {
    ref: "editable",
    attrs: {
      "contenteditable": ""
    },
    on: {
      "input": _vm.onInput
    }
  }), _vm._v(" "), (_vm.showPlaceHolder) ? _vm._c('div', {
    staticClass: "placeholder"
  }, [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1c087cec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/controls/Editable.vue
// module id = 630
// module chunks = 1